import type { AccountSubscription } from '@repo/utils/src/subscription/types';

import { IAccount } from '@/types/models';
import { ApiResponse } from '@/types/types';
import api from '@/utils/api';

export const getDashboardAccount = async () => {
  const { data } = await api.request<
    ApiResponse<{
      account: IAccount;
      accountSubscription: AccountSubscription | null;
      trialEligible: boolean;
    }>
  >({
    url: '/api/v1/auth/account/user',
    method: 'GET',
  });

  return data.data;
};
